import { useGetActiveRaffleQuery } from "../../store/api";
import { ActiveRaffle } from "../home/ActiveRaffle";
import { saveActiveRaffleAction } from "../../store/slices/raffle";
import { NoActiveRaffle } from "../home/NoActiveRaffle";
import { useAppDispatch } from "../../store/hooks/useAppDispatch";
import { RootState } from "../../store/types/rootState";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { Loading } from "../layout/loading";
import Footer from "../layout/footer";
import FAQDropdown from "../home/FAQDropdown";
import { Box, CircularProgress, Typography } from "@mui/material";
import WelcomeBox from "../home/WelcomeBox";
import { ActiveRaffle2 } from "../home/ActiveRaffle2";


export const Home = () => {
  const dispatch = useAppDispatch();

  const accountId = useAppSelector(
    ({ account }: RootState) => account.id,
  );

  const logo = useAppSelector(
    ({ account }: RootState) => account.logo,
  );

  const { data: activeRaffleFounded, isLoading: isLoadingGetActiveRaffle, error: errorGetActiveFaffle, isUninitialized } = useGetActiveRaffleQuery(accountId, {
    skip: accountId === "default" || accountId === "",
  });
  if (!isLoadingGetActiveRaffle && !errorGetActiveFaffle && !isLoadingGetActiveRaffle && activeRaffleFounded) {
      dispatch(saveActiveRaffleAction(activeRaffleFounded));
  }

  const getTemplateByRaffle = (templateId: string | undefined) => {
    switch (templateId) {
      case 'default':
        return activeRaffleFounded && <ActiveRaffle activeRaffle={activeRaffleFounded} />
      case 'template1':
        return activeRaffleFounded && <ActiveRaffle2 activeRaffle={activeRaffleFounded} />
      default:
        return activeRaffleFounded && <ActiveRaffle activeRaffle={activeRaffleFounded} />
    }
  }

  return !isLoadingGetActiveRaffle && !isUninitialized ? (
    <>
      {activeRaffleFounded ? getTemplateByRaffle(activeRaffleFounded.templateId) : <NoActiveRaffle logo={logo} />}
      {accountId !== 'oscar-alarcon' && accountId !== 'minas-de-baruta' && accountId !== 'oscar-alarcon-promo' && <Footer></Footer>}
    </>
  ) : accountId != 'default' ? <Box
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: 3,
          }}
        >
          <Typography variant="h4" fontWeight="bold" mb={2}>
            Buscando rifas disponibles
          </Typography>
          <CircularProgress />
  </Box> : <WelcomeBox></WelcomeBox>;
};
